import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[maxlength-limit-to]',
})
export class MaxLengthLimitToDirective {
    @Input('maxlength-limit-to') limitTo: any;

    constructor(private _el: ElementRef) {}

    @HostListener('keypress', ['$event']) onKeyPress(e: any) {
        const limit = +this.limitTo;
        if (e.target.value.length === limit && e.target.selectionEnd == e.target.selectionStart) {
            e.preventDefault();
        }
    }

    @HostListener('paste', ['$event']) onPaste(e: any) {
        const initialValueLength = this._el.nativeElement.value != null ? this._el.nativeElement.value.length : 0;
        let limit = +this.limitTo;

        limit = initialValueLength < limit ? limit - initialValueLength : limit;

        e.clipboardData.getData('text/plain').substring(0, limit);
    }
}

@Directive({
    selector: '[numbersOnly]',
})
export class OnlyNumberDirective {
    constructor(private _el: ElementRef) {}

    @HostListener('input', ['$event']) onInputChange(event: { stopPropagation: () => void }) {
        const initalValue = this._el.nativeElement.value;

        this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}

@Directive({
    selector: '[decimalsOnly]',
})
export class OnlyDecimalDirective {
    @Input('decimalsOnly') limitTo: any;
    constructor(private _el: ElementRef) {}

    @HostListener('input', ['$event']) onInputChange(event: { stopPropagation: () => void }) {
        const initialValue = this._el.nativeElement.value;
        const limit = +this.limitTo;

        let count = (initialValue.match(/,/g) || []).length;
        //Se controla que no se pueda meter mas de una coma
        if (count > 1) {
            let auxStr = initialValue.substring(0, initialValue.lastIndexOf(','));
            this._el.nativeElement.value = auxStr;
            event.stopPropagation();
            return;
        }
        //Se controla el numero de decimales
        if (count > 0) {
            let numDec = initialValue.substring(initialValue.indexOf(',') + 1).length;
            if (numDec > limit) {
                this._el.nativeElement.value = initialValue.substring(0, initialValue.length - 1);
                event.stopPropagation();
                return;
            }
        }
        //Se controla que el primer caracter no sea una coma
        if (initialValue == ',') {
            this._el.nativeElement.value = initialValue.replace(',', '');
        } else {
            this._el.nativeElement.value = initialValue.replace(/[^0-9,]*/g, '').replace();
        }

        if (initialValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
